import React from 'react';
import { Link } from 'react-router-dom';
import { advisers } from 'routes/routePaths';
import Card from 'shared/Cards/Card';
import { AdvisersSearchListProps } from './interface/advisersInterface';
import { useSelector } from 'react-redux';
import { getIsLoggedIn } from 'auth/store/selectors';

const { list: advisersList } = advisers;

const AdvisersSearchList: React.FC<AdvisersSearchListProps> = ({ data }) => {
  const isLogged = useSelector((state: any) => getIsLoggedIn(state));

  return (
    <div className="advisers-search-list">
      <p className="paragraph plum">Please confirm your selection</p>
      {data.map((item: any) => (
        <Link
          key={item[0].value}
          to={isLogged ? `${advisersList}/${item[0].id}` : `${advisers.add}?id=${item[0].id}`}
          className="block">
          <Card data={item} />
        </Link>
      ))}
    </div>
  );
};

export default AdvisersSearchList;
